// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `a,
a:hover,
a:focus {
  text-decoration: none;
  transition: 0.5s;
  outline: none; }

/* ------------ */
.text-primary {
  color: #5a8dee !important; }

.rc-accordion-toggle {
  display: flex;
  align-items: flex-start;
  cursor: pointer;
  justify-content: space-between;
  transition: 0.3s;
  align-items: center;
  padding: 1.3rem 0; }

.card-body {
  width: 70%;
  padding: 4rem 0 2rem; }

.rc-accordion-card {
  overflow: hidden;
  border-bottom: 1px solid #dadce0; }
  .rc-accordion-card:last-of-type {
    border-bottom: 0; }

.rc-accordion-title {
  font-weight: 400;
  font-size: 1.6rem;
  position: relative;
  color: #202124;
  margin: 0;
  transition: 0.3s; }

.rc-accordion-icon {
  position: relative;
  top: 2px;
  color: #475f7b;
  transition: 0.35s;
  font-size: 1.2rem; }

.rc-accordion-body {
  flex: 1 1 auto;
  min-height: 1px; }

.rc-accordion-body p {
  margin-bottom: 0;
  font-size: 14px;
  font-weight: 400;
  line-height: 24px;
  color: #727e8c;
  margin: 0;
  margin-bottom: 1rem;
  color: #4d5156;
  font-size: 1.6rem; }

.rc-collapse {
  position: relative;
  height: 0;
  overflow: hidden;
  transition: height 0.35s ease; }

.rc-collapse.show {
  height: auto; }
`, "",{"version":3,"sources":["webpack://./src/components/AccordionItem/AccordionItem.scss"],"names":[],"mappings":"AAAA;;;EAGE,qBAAqB;EACrB,gBAAgB;EAChB,aAAa,EAAA;;AAGf,iBAAA;AACA;EACE,yBAAyB,EAAA;;AAG3B;EACE,aAAa;EACb,uBAAuB;EACvB,eAAe;EACf,8BAA8B;EAC9B,gBAAgB;EAChB,mBAAmB;EACnB,iBAAiB,EAAA;;AAGnB;EACE,UAAU;EACV,oBAAoB,EAAA;;AAYtB;EACE,gBAAgB;EAChB,gCAAgC,EAAA;EAFlC;IAKI,gBAAgB,EAAA;;AAIpB;EACE,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,cAAc;EACd,SAAS;EAET,gBAAgB,EAAA;;AAKlB;EACE,kBAAkB;EAClB,QAAQ;EACR,cAAc;EACd,iBAAiB;EACjB,iBAAiB,EAAA;;AAEnB;EACE,cAAc;EACd,eAAe,EAAA;;AAEjB;EACE,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,cAAc;EACd,SAAS;EACT,mBAAmB;EACnB,cAAc;EACd,iBAAiB,EAAA;;AAEnB;EACE,kBAAkB;EAClB,SAAS;EACT,gBAAgB;EAChB,6BAA6B,EAAA;;AAE/B;EACE,YAAY,EAAA","sourcesContent":["a,\na:hover,\na:focus {\n  text-decoration: none;\n  transition: 0.5s;\n  outline: none;\n}\n\n/* ------------ */\n.text-primary {\n  color: #5a8dee !important;\n}\n\n.rc-accordion-toggle {\n  display: flex;\n  align-items: flex-start;\n  cursor: pointer;\n  justify-content: space-between;\n  transition: 0.3s;\n  align-items: center;\n  padding: 1.3rem 0;\n}\n\n.card-body {\n  width: 70%;\n  padding: 4rem 0 2rem;\n}\n// .rc-accordion-toggle:last-child {\n//   border-bottom: 0px;\n// }\n// .rc-accordion-toggle.active {\n//   background-color: #5a8dee;\n// }\n// .rc-accordion-toggle.active .rc-accordion-icon {\n//   transform: rotate(180deg);\n//   color: #fff;\n// }\n.rc-accordion-card {\n  overflow: hidden;\n  border-bottom: 1px solid #dadce0;\n\n  &:last-of-type {\n    border-bottom: 0;\n  }\n}\n\n.rc-accordion-title {\n  font-weight: 400;\n  font-size: 1.6rem;\n  position: relative;\n  color: #202124;\n  margin: 0;\n\n  transition: 0.3s;\n}\n// .rc-accordion-toggle.active .rc-accordion-title {\n//   color: #fff;\n// }\n.rc-accordion-icon {\n  position: relative;\n  top: 2px;\n  color: #475f7b;\n  transition: 0.35s;\n  font-size: 1.2rem;\n}\n.rc-accordion-body {\n  flex: 1 1 auto;\n  min-height: 1px;\n}\n.rc-accordion-body p {\n  margin-bottom: 0;\n  font-size: 14px;\n  font-weight: 400;\n  line-height: 24px;\n  color: #727e8c;\n  margin: 0;\n  margin-bottom: 1rem;\n  color: #4d5156;\n  font-size: 1.6rem;\n}\n.rc-collapse {\n  position: relative;\n  height: 0;\n  overflow: hidden;\n  transition: height 0.35s ease;\n}\n.rc-collapse.show {\n  height: auto;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
